// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-border[data-v-6b05922e] {\n  border-top: 8px solid white;\n  border-right: 8px solid white;\n  border-bottom: 1px solid #e5e7eb;\n}\n.customBorder[data-v-6b05922e]:hover {\n  border-radius: 100px;\n}\n.customBorderBlack[data-v-6b05922e]:hover, .customBorderBlackActive[data-v-6b05922e] {\n  border-radius: 100px;\n  border: 1px solid #010a11;\n}\n.customBorderBlack[data-v-6b05922e] {\n  border-radius: 100px;\n  border: 1px solid #fafafa;\n}", ""]);
// Exports
module.exports = exports;
